import { useFormik } from 'formik';
import React, { useState } from 'react'
import * as yup from "yup";
import { CloseIcon } from '../assets/icons';
import { CancelButton, SubmitButton } from './Button';
import useAddData from '../hooks/useAddData';
import useEditData from '../hooks/useEditData';

function CommomApproval({
    data,
    visible,
    onClose,
    refreshData,
    moduleId,
    id,
    moduleName="",
    standardName,
    getCompletion=()=>{}
}) {
    const { isCreateLoading, addData } = useAddData();
    const { isEditLoading, editData } = useEditData();
    const [createNew, setCreateNew] = useState({
        module_id: "",
        status_name: "review_and_approved",
        module_name:"",
        standard_id:""
    
      });

      const formik = useFormik({
        enableReinitialize: true,
        initialValues: createNew,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (value,{resetForm}) => {
          value.standard_id = Number(id) || "";
          value.module_id = moduleId;
          if (data?.id) {
            editData({
                url: `/review_and_approved/${data?.id}`,
                value: value,
                resetForm: resetForm,
                onClose: onClose,
                getData: refreshData,
                otherFunction:getCompletion
            })
          } else {
            addData({
                url: `/review_and_approved/`,
                value: value,
                resetForm: resetForm,
                onClose: onClose,
                getData: refreshData,
                otherFunction:getCompletion
            })
          }
        },
      });
    
      if (!visible) return null;

  return (
    <>
           <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-4/12">
        <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={onClose}
            >
                <CloseIcon/>
            </span>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <p className=' text-xl 2xl:text-2xl font-medium text-center mb-3'>Are you sure ?</p>
            <p className=' text-sm 2xl:text-base text-center px-3'>You want Appove {moduleName} from the standard {standardName}</p>
          <div className="flex w-full items-center justify-end px-3 pt-6 pb-2 rounded-b text-xs 2xl:text-sm">
                <CancelButton onClose={onClose} isLoading={isCreateLoading||isEditLoading} />
                <SubmitButton label='Approve' isLoading={isCreateLoading||isEditLoading}  />
              </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default CommomApproval